import styled from "styled-components"
import H3 from "../../atoms/typography/H3"
import { forwardRef } from "react"
import BodyMedium from "../../atoms/typography/BodyMedium"
import * as Aria from "react-aria-components"
import { theme } from "../../theme"

export interface InputboxProps extends Aria.TextFieldProps, Pick<Aria.InputProps, "placeholder"> {
  label?: string
}

const TextFieldStyle = styled(Aria.TextField)`
  display: grid;
  row-gap: 1rem;

  &[data-disabled] {
    color: ${({ theme }) => theme.colors.greyDisabled};
  }
`

const InputStyle = styled(BodyMedium)`
  outline: none;
  background: none;
  color: inherit;

  border: solid 0 ${({ theme }) => theme.colors.greyDark};
  border-color: inherit;
  border-bottom-width: 2px;
  padding-bottom: 6px;

  &::placeholder {
    color: ${({ theme }) => theme.colors.greyDisabled};
    font-style: italic;
  }
`

const LabelStyle = styled(H3)`
  color: inherit;
`

const Inputbox = forwardRef<HTMLInputElement, InputboxProps>(({ label, placeholder, ...props }, ref) => {
  return (
    <TextFieldStyle {...props}>
      {label && <LabelStyle as={Aria.Label}>{label}</LabelStyle>}
      <InputStyle as={Aria.Input} ref={ref} placeholder={placeholder} />
      <H3 color={theme.colors.red}>
        <Aria.FieldError />
      </H3>
    </TextFieldStyle>
  )
})

export default Inputbox
